import codificadoJson from './data/codificado.json';
import penalJson from './data/penal.json';
import constitucionJson from './data/constitucion.json';
import type { CodifiedData, LawData, PenalData } from './types';

export * from './types';
export { normalize } from './search';

/** Guía codificada de infracciones urbanas de seguridad vial (IESPA). */
export const codificado = codificadoJson as unknown as CodifiedData;

/** Código Penal (LO 10/1995, versión consolidada). */
export const penal = penalJson as unknown as PenalData;

/** Constitución Española de 1978 (texto consolidado BOE-A-1978-31229). */
export const constitucion = constitucionJson as unknown as LawData;
